<div class="sub-folder">
    <div class="sub-folder-name" *ngFor="let subFolder of data;let i = index">
        <div class="border-line">
            <p class="line"></p>
        </div>
        <i class="bi bi-folder-fill"></i><p class="name">{{subFolder.label}}</p>
<app-menu [list]="subFolder.children"></app-menu>

    </div>
</div>